import {
  alpha,
  Box,
  Button,
  Card,
  Chip,
  Grid,
  Icon,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import SectionHeader from "./SectionHeader";
import KpiCard from "./KpiCard";
import { downloadFileCommon } from "../../../store/actions/commonAction";
import { useDispatch } from "react-redux";

export default function GrnReportModule({ data }) {
  const theme = useTheme();
  const dispatch = useDispatch();

  const downloadExcel = () => {
    // Implement the logic to download the data as an Excel file
    console.log("Download Excel clicked");
    let excelData = data?.executive?.map((supplier) => ({
      Supplier: supplier.supplier,
      "Total Invoice Value": supplier.totalInvoiceAmount,
      "Total Invoices": supplier.totalInvoiceCount,
      "Total GRNs": supplier.totalGrnCount,
      "Pending Receipt": supplier.pendingGrnCount,
    }));
    dispatch(
      downloadFileCommon({
        fileName: "supplier_report.xlsx",
        query: {},
        body: { data: excelData, docType: "supplier_report" },
        path: "/document/common/excel",
      }),
    );
  };

  return (
    <Box style={{ marginTop: 16 }}>
      <Grid container spacing={2} mb={3}>
        {[
          {
            title: "Total Invoice Value",
            value: `${data?.summary?.totalInvoiceAmount}`,
            icon: "currency_rupee",
            color: "#9C27B0",
          },
          {
            title: "Total Invoices",
            value: data?.summary?.invoiceCount,
            icon: "receipt_long",
            color: "#2196F3",
          },
          {
            title: "Total GRNs",
            value: data?.summary?.grnCount,
            icon: "inventory_2",
            color: "#4CAF50",
          },

          {
            title: "Pending Receipt",
            value: data?.summary?.pendingGrnCount,
            icon: "hourglass_empty",
            color: "#E53935",
            subtitle: `${
              data?.summary?.invoiceCount
                ? Math.round(
                    (data?.summary?.pendingGrnCount /
                      data?.summary?.invoiceCount) *
                      100,
                  )
                : 0
            }% of total`,
          },
        ].map((k) => (
          <Grid item xs={6} sm={4} md={3} key={k.title}>
            <KpiCard {...k} />
          </Grid>
        ))}
      </Grid>

      <Card
        elevation={0}
        sx={{ borderRadius: 3, border: `1px solid ${theme.palette.divider}` }}
      >
        <Box px={2.5} pt={2}>
          <SectionHeader
            title="Supplier-wise Details"
            subtitle="Complete receipt ledger for selected filters"
            action={
              <Button
                size="small"
                variant="outlined"
                startIcon={<Icon fontSize="small">file_download</Icon>}
                sx={{ textTransform: "none" }}
                onClick={downloadExcel}
              >
                Export Excel
              </Button>
            }
          />
        </Box>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow
                sx={{
                  "& th": {
                    fontWeight: 700,
                    bgcolor: alpha(theme.palette.primary.main, 0.06),
                    fontSize: 11,
                    textTransform: "uppercase",
                    letterSpacing: 0.4,
                    py: 1.2,
                    whiteSpace: "nowrap",
                  },
                }}
              >
                <TableCell>Supplier</TableCell>
                <TableCell>Total Invoice Value</TableCell>
                <TableCell>Total Invoices</TableCell>
                <TableCell>Total GRNs</TableCell>
                <TableCell>Pending Receipt</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.executive?.map((supplier, index) => (
                <TableRow key={`supplier-${index}`} hover>
                  <TableCell>
                    <Typography variant="caption" fontWeight={600}>
                      {supplier.supplier}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="caption"
                      fontWeight={700}
                      color="primary.main"
                    >
                      {supplier.totalInvoiceAmount}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption">
                      {supplier.totalInvoiceCount}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Chip
                      label={supplier.totalGrnCount}
                      size="small"
                      variant="outlined"
                      sx={{ fontSize: 10, height: 20 }}
                    />
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption">
                      {supplier.pendingGrnCount}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
}
